// snippet: rcep
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskLayout.styles';
import {
  KioskMainHeader,
  KioskFooter,
  KioskBackgroundSlider,
  KioskSlides
} from '..';

export class KioskLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    height: '530'
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classNames(classes.container)}>
        <KioskMainHeader myLogoheight={this.state.height} />
        <KioskSlides />
        <KioskBackgroundSlider />
        <KioskFooter customFooterBottom="0%" />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskLayout);
